/**
 * Disables [data-call-rep-hours] buttons outside of business hours in the
 * specified timezone. Reads:
 *   data-call-rep-hours="9-18"      24-hour start-end (end is exclusive)
 *   data-call-rep-tz="Asia/Karachi" IANA timezone (defaults to Asia/Karachi)
 *
 * When closed, the button gets `.btn--call-rep--closed` and clicks are
 * suppressed via preventDefault so the tel: link never fires.
 */
(function () {
  function getHourIn(tz) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour: 'numeric',
        hour12: false,
      });
      var h = parseInt(fmt.format(new Date()), 10);
      // In some locales 24 is returned for midnight; normalize to 0
      if (h === 24) h = 0;
      return h;
    } catch (e) {
      return null;
    }
  }

  function applyState(el) {
    var tz = el.getAttribute('data-call-rep-tz') || 'Asia/Karachi';
    var range = (el.getAttribute('data-call-rep-hours') || '9-18').split('-');
    var start = parseInt(range[0], 10);
    var end = parseInt(range[1], 10);
    var hour = getHourIn(tz);

    if (hour === null || isNaN(start) || isNaN(end)) {
      return;
    }

    var open;
    if (start <= end) {
      // Same-day range, e.g. 9-18
      open = hour >= start && hour < end;
    } else {
      // Overnight range, e.g. 22-6
      open = hour >= start || hour < end;
    }

    if (open) {
      el.classList.remove('btn--call-rep--closed');
      el.removeAttribute('aria-disabled');
    } else {
      el.classList.add('btn--call-rep--closed');
      el.setAttribute('aria-disabled', 'true');
    }
  }

  function init() {
    var buttons = document.querySelectorAll('[data-call-rep-hours]');
    if (!buttons.length) return;

    Array.prototype.forEach.call(buttons, function (el) {
      applyState(el);
      el.addEventListener('click', function (e) {
        if (el.classList.contains('btn--call-rep--closed')) {
          e.preventDefault();
        }
      });
    });

    // Re-check every minute so the state flips correctly if the page is open
    // across the open/close boundary.
    setInterval(function () {
      Array.prototype.forEach.call(buttons, applyState);
    }, 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
